<p-popover
  #contactPopover
  styleClass="contact-info-popover"
  (onHide)="onPopoverHide()"
  appendTo="body">
  @if (!isEmptyData) {
    <div class="contact-list">
      @for (
        user of filterPrimaryContact(passingData.primaryContact);
        track user.EMAIL + '-' + user.ORDER + '-' + $index
      ) {
        <div class="contact-card">
          @if (!user['FIRST NAME'] && !user['LAST NAME']) {
            <div class="contact-card__name">
              {{ user.EMAIL | NameEmail }}
            </div>
          } @else {
            <div class="contact-card__name">
              {{ user['FIRST NAME'] + ' ' + user['LAST NAME'] }}
            </div>
          }

          <div class="contact-card__order">{{ user.ORDER }}</div>

          <div class="contact-card__title">{{ user.TITLE }}</div>

          <div class="contact-card__phone">
            <svg-icon
              class="contact-card__icon"
              [class.contact-card__icon--active]="
                checkDomain('true', user.EMAIL)
              "
              key="phone"
              size="md"
              (click)="
                makeCallMsTeams(user.EMAIL, checkDomain('true', user.EMAIL))
              "></svg-icon>

            @if (user.PHONE) {
              <div
                class="contact-card__value contact-card__value--link"
                (click)="makeCall(user.PHONE)">
                {{ user.PHONE }}
              </div>
            } @else {
              <div class="contact-card__value">N/A</div>
            }

            <svg-icon
              class="contact-card__copy"
              key="clipBoard"
              size="md"
              (click)="copyText(user.PHONE || 'N/A')"></svg-icon>
          </div>

          <div class="contact-card__email">
            @if (user.EMAIL) {
              <div
                class="contact-card__value contact-card__value--link"
                (click)="makeMailMsOutlook(user.EMAIL, '', '')">
                {{ user.EMAIL }}
              </div>
            } @else {
              <div class="contact-card__value">N/A</div>
            }

            <svg-icon
              class="contact-card__copy"
              key="clipBoard"
              size="md"
              (click)="copyText(user.EMAIL || 'N/A')"></svg-icon>
          </div>
        </div>
      }
    </div>
  }

  @if (isEmptyData) {
    <div class="contact-empty">
      {{ passingData.primaryContact }}
    </div>
  }
</p-popover>
